module.exports = __webpack_public_path__ + "static/media/miel-lapiquera-frasco.866ff249.jpg";